import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';
import { CurrencyFormat } from '../../waitingnotes.component';

@Component({
  selector: 'app-overpayment-dialog',
  templateUrl: './over-payment-dialog.component.html',
})
export class OverPaymentDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<OverPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { overpayment: number, currencyFormat: CurrencyFormat },
    public cssService: CssService
  ) {
    // console.log("data : ", data);
 }

  isClosing = false;
  selectedOption: string | null = null;

  onClose(action: string): void {
    this.selectedOption = action;
    this.isClosing = true;
  }

  onAnimationEnd() {
    if (this.isClosing)
      this.dialogRef.close(this.selectedOption);
  }
}
